import gql from 'graphql-tag'

export const QUERY_LIST_TEMPLATE_MESSAGE = gql`
  query MessageTemplates(
    $page: Int
    $pageSize: Int
    $tags: [ID!]
    $channels: [CampaignMode!]
    $search: String
    $sort: [String]
    $sortDirection: [SortDirection]
  ) {
    messageTemplates(page: $page, pageSize: $pageSize, tags: $tags, channels: $channels, search: $search, sort: $sort, sortDirection: $sortDirection) {
      page
      records
      templates {
        _id
        message
        from_campaign
        tags {
          _id
          color
          name
          origin
        }
        channels
        quantity_used
        created_at
        updated_at
      }
    }
  }
`

export const QUERY_LIST_TEMPLATE_MESSAGE_TAGS = gql`
  query MessageTemplateTags($page: Int, $pageSize: Int, $sort: [String], $sortDirection: [SortDirection]) {
    messageTemplateTags(page: $page, pageSize: $pageSize, sort: $sort, sortDirection: $sortDirection) {
      page
      records
      tags {
        _id
        color
        name
        origin
      }
    }
  }
`
